import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconNumber7Circle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"number-7-circle"} maskId="square-filled-radius-0-stroke-1-IconNumber7Circle"><path fillRule="evenodd" clipRule="evenodd" d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM9.15234 7.79492V8.73828H13.6758V8.82031L9.87891 16.25H10.9863L14.748 8.77344V7.79492H9.15234Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconNumber7Circle;
